import { render, staticRenderFns } from "./basic-info.vue?vue&type=template&id=5b056787&"
import script from "./basic-info.vue?vue&type=script&lang=ts&"
export * from "./basic-info.vue?vue&type=script&lang=ts&"
import style0 from "./basic-info.vue?vue&type=style&index=0&id=5b056787&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports